import { useEffect, useState } from "react";
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { makeSideBarActive } from "../../utils/EllowUtils";
import { useForm } from "react-hook-form";
import { DropDownInput } from "../../wrappers/selectInput";
import { FormInput } from "../../wrappers/formInput";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import * as SKILLS from "../../utils/Skill";
import Datepicker from "../../components/datepicker";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Error } from "@progress/kendo-react-labels";
import * as Utils from "../../utils/EllowUtils";
import UploadFiled from "../../components/fileduploader";
import RangeSelector from "../../components/rangeSlider";
import CheckboxDefault from "../../components/checkbox";
import { uploadApi } from "../../api/api";
import { postAPI } from "../../api/api";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  Modifier,
  ContentState,
} from "draft-js";
import { useLocation } from "react-router-dom";
import FromHead from "../../components/headings/FromHead";
import PlacesAutocomplete, { geocodeByAddress, geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';
import RadioButton from '../../components/radio';
import { Icon } from "@iconify/react";
import Toggle from "../../components/toggleButton";
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";


export type CreatePositionsFormFields = {
  postPosition: string;
  jobRole: string;
  jobType: string;
  priority: string;
  title: string;
  resources: string;
  coreSkills: string;
  otherSkills: string;
  jobDescription: string;
  jobResponsibilities: string;
  supportingDocument: string;
  contractDuration: number;
  billingType: string;
  currencyType: string;
  minimumBudget: number;
  maximumBudget: number;
  locationPreference: any;
  contractStartDate: any;
  noticePeriod: any;
  companyDetails: any;
};

interface Props {
  save: any,
  publish: any,
  postPositions: [{ companyName: string, companyId: string }],
  skillsList: any;
  jobRolesList: any;
}

const validationSchema = Yup.object({
  postPosition: Yup.object().required("Field is required"),
  title: Yup.string().required("Field is required"),
  jobType: Yup.string().required('Field is required').nullable(),
  jobRole: Yup.object().required("Field is required").nullable(),
  coreSkills: Yup.array().required("Field is required").max(3,'Maximum three skills are allowed'),
  resources: Yup.string().required("Field is required").nullable(),
  // contractDuration: Yup.string().required("Field is required").nullable(),
  billingType: Yup.string().required("Field is required").nullable(),
  currencyType: Yup.string().required("Field is required").nullable(),
  minimumBudget: Yup.string().required("Field is required").nullable(),
  maximumBudget: Yup.string().required("Field is required").nullable(),
});

const CreatePositions: React.FC<Props> = (
  {
    save,
    publish,
    postPositions,
    skillsList,
    jobRolesList
  }
) => {

  const location = useLocation();
  const { data , jobId, jobStatus ,  publishKey }: any = location.state || ''

  const formOptions = {
    resolver: yupResolver(validationSchema)
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm<CreatePositionsFormFields>(formOptions);

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1);
  const breadCrums = ['Positions', 'Create New Position']

  const [checked, setChecked] = useState<boolean>(false);
  const [keyValue , setKeyValue] = useState()
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty());
  const [editorState2, setEditorState2] = useState<any>(EditorState.createEmpty());
  const { v4: uuidv4 } = require("uuid");
  const [error, setError] = useState<{ startDate?: string}>({ startDate: ""});
  const [error2, setError2] = useState<string>('')
  const [experienceRange, setExperienceRange] = useState<{min?: number , max?: number}>({min: 0 , max: 20});
  const [resourceCount , setResourceCount] = useState<string>()
  const [contractDuration , setContractDuration] = useState<string>()    
  const [minimumBudget , setMinimumBudget] = useState<string>() 
  const [maximumBudget, setMaximumBudget] = useState<string>() 
  const [flag1, setFlag1] = useState<boolean>(false)
  const [flag, setFlag] = useState<boolean>(false)
  const [locationPreference, setlocationPreference] = useState<number>()
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])
  const [address, setAddress] = useState('')
  const [Errors, setErrors] = useState<string>('')
  const [document, setDocument] = useState<string>()
  const [disabled , setDisabled] = useState<boolean>(false)
  const [disabledSave , setDisabledSave ] = useState<boolean>(false)
  const [closedCount , setClosedCount ] = useState<any>(0)
  const [lossCount , setLossCount] = useState<any>(0)
  const [toggleButton, setToggleButton] = useState<any>()
 
  let date:any = data && data.job_metadata && data.job_metadata.contractStartDate ? new Date(parseInt(data.job_metadata.contractStartDate)) :0

  useEffect(() => {  

    if (data && data.job_metadata) {
      setKeyValue(publishKey)
      setValue('jobDescription', data.job_metadata.jobDescription)
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== data.job_metadata.jobDescription) {
        try {
          setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(data.job_metadata.jobDescription)))); 
        }
        catch (e) {
          setEditorState(EditorState.createWithContent(ContentState.createFromText(data.job_metadata.jobDescription)));
        }
      }
      if(data.job_metadata.contractStartDate === 0){
        setChecked(true)
      }
      
      setResourceCount(data.job_metadata.resourceCount)
      data.job_metadata.priority = { name: Utils.checkPriority(data.job_metadata.priority), id: data.job_metadata.priority }
      setExperienceRange(data.job_metadata.experienceRange)
      reset(data.job_metadata)
      if (data.job_metadata && data.job_metadata.locationPreference) {
        setLocationArray(data.job_metadata.locationPreference.location)
        setlocationPreference(data.job_metadata.locationPreference.remoteType)  
        if(data.job_metadata.locationPreference.remoteType === 1 ){
          setFlag(true)
        }
        if(data.job_metadata.locationPreference.remoteType === 2){
          setFlag1(true)   
        }
      }
      setClosedCount(data.job_metadata.closedCount)
      setLossCount(data.job_metadata.lossCount)
      setValue('supportingDocument', data.job_metadata.supportingDocument.length > 0 ? data.job_metadata.supportingDocument.slice(36) : '')
    } 
    if(data && data.crowdsourcing_enabled){
        setToggleButton(data.crowdsourcing_enabled)
        setValue("companyDetails", data.crowdsourcing_company_details)
        setEditorState2(EditorState.createWithContent(convertFromRaw(JSON.parse(data.crowdsourcing_company_details)))) 
    }

  }, [data]);

  useEffect(() => {
    
    if (data && data.job_metadata && data.job_metadata.contractStartDate) {
      setValue('contractStartDate',date)
    }
 
  }, [data && data.job_metadata && data.job_metadata.contractStartDate])
  
   
  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    setValue("jobDescription", JSON.stringify(convertToRaw(contentState)));
  }

  const onEditorStateChange2 = (state: any) => {
    setError2('')
    setEditorState2(state);
    const contentState = state.getCurrentContent();
    setValue("companyDetails", JSON.stringify(convertToRaw(contentState)));
  }

  useEffect(() => {
    
    clearErrors()
  
  }, [watch().title])
  

  const saveValues = (e: any) => {
    
    let hasError: boolean = false
    e.preventDefault()
    if (locationPreference){
      if( locationPreference === 1 || locationPreference === 2){
        if (!locationArray || locationArray.length === 0){
          hasError = true
          setErrors('Field is required')
        }
      }
    }

    if (watch().title) {
      let data = watch()
      let value ={
      data: data,
      experienceRange: experienceRange,
      supportingDocument: document !== undefined ? document : '',
      jobId: jobId && jobId ? jobId : '',
      locationPreference: {
          remoteType: locationPreference,
          location: locationPreference ===  1 || locationPreference ===  2 ? locationArray : []
      } 

      }
      let counts = {
        closedCount: closedCount,
        lossCount : lossCount
      }
      
      if(toggleButton === true){
        if(!data.companyDetails){
          hasError = true
          setError2('Field is required')
        }
      }
      
      if (!hasError) {
        setDisabledSave(true)
        save(value, counts, toggleButton)
     }
    }
    else {
      let value = watch();
      trigger()
    }
  }


  const publishValues = (data: any) => {   
  
    let hasError: boolean = false

    if (locationPreference){
      if( locationPreference === 1 || locationPreference === 2){
        if (!locationArray || locationArray.length === 0){
          hasError = true
          setErrors('Field is required')
        }
      }
    }
 
    if(toggleButton === true){
      if(!data.companyDetails){
        hasError = true
        setError2('Field is required')
      }
    }

    if (data.startDate) {
      data.startDate = Utils.getMilliSecUTC(data.startDate)
    }
    if(data.jobType === 'Full time'){
      data.contractDuration = null
      data.startDate = null
    }else{
      data.noticePeriod = null
    }
    let value ={
      data: data,
      experienceRange: experienceRange,
      jobId : jobId && jobId ? jobId : '',
      key: keyValue,
      supportingDocument: document !== undefined ? document : '',
      locationPreference: {
        remoteType: locationPreference,
        location: locationPreference ===  1 || locationPreference ===  2 ? locationArray : []
      } 
    } 
    let counts = {
      closedCount: closedCount,
      lossCount : lossCount
    }  
    if (!hasError) {
      setDisabled(true)
      publish(value, counts, toggleButton)
    } 
  }

  const uploadFile = (e: any) => {
    let fileExtension = e.target.files[0].name.split(".").pop();
    if (fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx") {

      let file = e.target.files[0]
      let type = file.type

      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");

      let value = {
        "action":"putObject",
        "filename":fileName
      }

      postAPI( REACT_APP_CANDIDATE_FRELLANCER + '/getsignedurlforresume',value).then((data) => {
        let signedUrl = data.url;
        uploadApi(signedUrl, file, type).then((response: any) => {
          setDocument(fileName)
          setValue('supportingDocument', fileName.slice(36, fileName.length))
        })
      })
    }
  };


  const handleChange = (e: any, name: any) => {
    setValue(name, e.target.value);
    if (name === "startDate") {
      delete error?.startDate;
      setError({ ...error });
    }
    if( name === 'remoteOnly'){
      setFlag1(false)
      setFlag(false)
      setlocationPreference(0)
      setLocationArray([])
      setErrors('')
    }
    if(name ==='NA'){
      delete errors.locationPreference
      setFlag(false)  
      setFlag1(false)   
      setLocationArray([]) 
      setlocationPreference(3)
      setErrors('')
    }
    if(name ==='locationOnly'){
      delete errors.locationPreference
      setFlag(true)  
      setFlag1(false)   
      setLocationArray([]) 
      setlocationPreference(1)
      setErrors('')
    }
      if ( name === 'Hybrid'){
      delete errors.locationPreference
      setFlag1(true)  
      setLocationArray([])
      setFlag(false)    
      setlocationPreference(2)
      setValue('locationPreference', e.value)
      setErrors('')
    }
    if(name === "resources")
    {
      setResourceCount(e.target.value ? Math.abs(e.target.value).toString() : '')
    } 
    if(name === "contractDuration")
    {
      setContractDuration(e.target.value ? Math.abs(e.target.value).toString() : '')
    } 
    if(name === "minimumBudget")
    {
      setMinimumBudget(e.target.value ? Math.abs(e.target.value).toString() : '')
    } 
    if(name === "maximumBudget")
    {
      setMaximumBudget(e.target.value ? Math.abs(e.target.value).toString() : '')
    }
  }

  const changeOn = (e: any, name: any) => {
    if (name === "checked") {
      if (e.target.value === true) {
        setChecked(true);
        delete error?.startDate;
        setError({ ...error });
      } else {
        setChecked(false);
      }
    }
  };
  
  const experienceLevel = (start: any , end: any) =>{
      let value = {
        min : start ,
        max : end
      }
      setExperienceRange(value)
  }

  const handleSelect = async (value: any) => {

    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
    setErrors('')
  }

  
  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  const toggleChange = (e: any) => {
    if(e.value === true){
      setToggleButton(true)
      if(data && data.crowdsourcing_company_details){
        setValue("companyDetails", data.crowdsourcing_company_details)
        setEditorState2(EditorState.createWithContent(convertFromRaw(JSON.parse(data.crowdsourcing_company_details)))) 
      }
    }else{
      setToggleButton(false)
    }
  }
  return (
    <form>
      <div className={Styles.createWrap}>
            <div className="half-form-wrap">
              <div className="form-group">
                <label className="lablel">Post position on behalf of*</label>
                <DropDownInput<CreatePositionsFormFields>
                  name="postPosition"
                  label=""
                  data={postPositions}
                  register={register}
                  errors={errors}
                  control={control}
                  dataItemKey="companyId"
                  textField="companyName"
                />
              </div>
              <div className="form-group">
                <label className="lablel">Title*</label>
                <FormInput<CreatePositionsFormFields>
                  id="title"
                  type="text"
                  name="title"
                  placeholder="Enter the position title"
                  register={register}
                  errors={errors}
                />
              </div>
            </div>
            <div className="half-form-wrap">
              <div className="form-group">
                <label className="lablel">How many resources you need?*</label>
                <FormInput<CreatePositionsFormFields>
                  id="resources"
                  type="number"
                  name="resources"
                  value={resourceCount}
                  placeholder="Enter the resources"
                  register={register}
                  errors={errors}
                  onchange={(e: any) => handleChange(e, "resources")}
                />
              </div>
              <div className="form-group">
                <label className="lablel">Job Role*</label>
                <DropDownInput<CreatePositionsFormFields>
                  name="jobRole"
                  data={jobRolesList}
                  register={register}
                  errors={errors}
                  control={control}
                  dataItemKey="id"
                  textField="name"
                />
              </div>
            </div>
            <div className="half-form-wrap">
              <div className="form-group">
                <label className="lablel">Type of job</label>
                <DropDownInput<CreatePositionsFormFields>
                  name="jobType"
                  data={CONSTANTS.typeOfJob}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </div>
              <div className="form-group">
                <label className="lablel">
                  Experience range &nbsp;<strong>{experienceRange && experienceRange.min} - {experienceRange && experienceRange.max}</strong>
                </label>
                <RangeSelector
                  defaultValue={data && data.job_metadata&& data.job_metadata.experienceRange}
                  onChange={(e: any) => experienceLevel(Math.floor(e.value.start) , Math.floor(e.value.end))}
                />
              </div>
            </div>
            <div className="half-form-wrap">
              <div className="form-group">
                <label className="lablel">Priority</label>
                <DropDownInput<CreatePositionsFormFields>
                  name="priority"
                  data={CONSTANTS.priority}
                  register={register}
                  errors={errors}
                  control={control}
                  dataItemKey="id"
                  textField="name"
                />
              </div>
            </div>
            <div className="form-wrap">
              <div className="form-group">
                <label className="lablel">
                  Core Skills in the order of expertise*
                </label>
                <MultiDropDownInput<CreatePositionsFormFields>
                  control={control}
                  data={skillsList && skillsList.length > 0 &&  Utils.skillNameConverter(skillsList)}
                  textField="skillName"
                  name="coreSkills"
                  placeholder="Enter Core Skills"
                  register={register}
                  errors={errors}
                  onChange={(e: any) => handleChange(e, "skills")}
                  dataItemKey="skillId"
                  allowCustom={false}
                />
              </div>
            </div>
            <div className="form-group">
                <label className="lablel">Other Skills</label>
                <MultiDropDownInput<CreatePositionsFormFields>
                  control={control}
                  data={skillsList && skillsList.length > 0 &&  Utils.skillNameConverter(skillsList)}
                  textField="skillName"
                  name="otherSkills"
                  placeholder="Enter your services here"
                  register={register}
                  onChange={(e: any) => handleChange(e, "skills")}
                  dataItemKey="skillId"
                  errors={errors}
                  allowCustom={false}

                />
            </div>
            <div className="form-wrap">
              <div className="form-group">
                <label className="lablel">Job Description</label>
                <Editor
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChange}
                />
              </div>
            </div>
        <FromHead>Work Location</FromHead>
        <div className="mb-40">
         <div className="form-group">
           <RadioButton
               name="locationPreference"
               label="Remote Only" 
               value={1} 
               defaultChecked={false}
               handleChange={(e: any) => handleChange(e, 'remoteOnly')} 
               checked={locationPreference === 0 }
            />
             </div>
             <div className="form-group">
              <RadioButton
                  name="locationPreference"
                  label="Onsite Only" 
                  value={2} 
                  defaultChecked={false}
                  handleChange={(e: any) => handleChange(e, 'locationOnly')} 
                  checked={ locationPreference === 1}
                />
             </div>
             
          <div className={Styles.tagListGroup}>
             {flag && locationArray && locationArray.map((item) => {
               return (
                <div className={Styles.tagListItem}>
                  {item.name} <Icon icon="eva:close-outline" onClick={() => removeLocation(item)}/>
                </div>
               )
             })}
             </div>

           <div className='preference-form-wrapper'>
           <div className="form-group">
                {flag && <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
             <div className="form-group">
              <RadioButton
                  name="locationPreference"
                  label="Hybrid" 
                  value={3} 
                  defaultChecked={false}
                  handleChange={(e: any) => handleChange(e, 'Hybrid')} 
                  checked={ locationPreference === 2}
                />
             </div>

          <div className={Styles.tagListGroup}>
             {flag1 && locationArray && locationArray.map((item) => {
               return (
                <div className={Styles.tagListItem}>
                  {item.name} <Icon icon="eva:close-outline" onClick={() => removeLocation(item)}/>
                </div>
               )
             })}
          </div>
           <div className='preference-form-wrapper'>
           <div className="form-group">
                {flag1 && <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input 
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
          <Error>{Errors}</Error>
          <div className="form-group">
           <RadioButton
               name="locationPreference"
               label="NA" 
               value={4} 
               defaultChecked={false}
               handleChange={(e: any) => handleChange(e, 'NA')} 
               checked={locationPreference === 3 }
            />
             </div>
        </div>
            <div className="form-wrap">
              <div className="form-group">
                <label className="lablel">Any additional supporting document?(optional)</label>
                <div className="uploadWrap">
                  <FormInput<CreatePositionsFormFields>
                    id="supportingDocument"
                    type="text"
                    name="supportingDocument"
                    placeholder="Enter your services here"
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                  <UploadFiled uploadFile={uploadFile} />
                </div>
              </div>
            </div>
            <div className="form-wrap">
                <FromHead>Crowdsourcing</FromHead>
                <div className={Styles.tggleBtn}>
                  <Toggle onChange={toggleChange} defaultChecked={data && data.crowdsourcing_enabled}/>
                </div>
            </div>
            {toggleButton === true && 
              <div className="form-wrap">
                <div className="form-group">
                  <label className="lablel">About the company</label>
                  <Editor
                    editorState={editorState2}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    onEditorStateChange={onEditorStateChange2}
                  />
                   <Error>{error2}</Error>
                </div>
              </div>
            }
            { watch().jobType !== 'Full time' && <div>
            <div className="half-form-wrap">
              <div className="form-group">
                <label className="lablel">Contract Period*</label>
                <DropDownInput<CreatePositionsFormFields>
                  name="contractDuration"
                  data={CONSTANTS.contractDuration}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </div>
              <div className="form-group">
                <div className={Styles.datelabel}>
                  <label className="lablel">Start date</label>
                  <CheckboxDefault
                    defaultChecked={data && data.job_metadata && data.job_metadata.contractStartDate === 0 ? true : false}
                    onchange={(e: any) => changeOn(e, "checked")}
                    label=" Immediate"
                  />
                </div>
                <Datepicker
                  defaultShow={false}
                  defaultValue={date}
                  onChange={(e: any) => handleChange(e, "startDate")}
                  disabled={checked ? true : false}
                />
                <Error>{error?.startDate}</Error>
              </div>
            </div>
            </div>
            }
            { watch().jobType === 'Full time' && <div className="half-form-wrap">
            <div className="form-group">
            <label className="lablel">Preferred Notice period in Days</label>
              <FormInput<CreatePositionsFormFields>
                  id="noticePeriod"
                  // type="text"
                  name="noticePeriod"
                  placeholder="Enter your notice period"
                  register={register}
                  errors={errors}
                  type='number'
              />
              </div>
            </div>}
            <div className="half-form-wrap">
              <div className="form-group">
                <div className="half-form-wrap">
                  <div className="form-group">
                    <label className="lablel">Billing Type*</label>
                    <DropDownInput<CreatePositionsFormFields>
                      name="billingType"
                      data={CONSTANTS.billingType}
                      register={register}
                      errors={errors}
                      control={control}
                    />
                  </div>
                  <div className="form-group">
                    <label className="lablel">Currency*</label>
                    <DropDownInput<CreatePositionsFormFields>
                      name="currencyType"
                      data={CONSTANTS.currency}
                      register={register}
                      errors={errors}
                      control={control}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="half-form-wrap">
                  <div className="form-group">
                    <label className="lablel">Minimum Budget*</label>
                    <FormInput<CreatePositionsFormFields>
                      id="minimumBudget"
                      type="number"
                      name="minimumBudget"
                      value={minimumBudget}
                      placeholder="Minimum"
                      register={register}
                      errors={errors}
                      onchange={(e: any) => handleChange(e, "minimumBudget")}
                    />
                  </div>
                  <div className="form-group">
                    <label className="lablel">Maximum Budget*</label>
                    <FormInput<CreatePositionsFormFields>
                      id="maximumBudget"
                      type="number"
                      name="maximumBudget"
                      value={maximumBudget}
                      placeholder="Maximum"
                      register={register}
                      errors={errors}
                      onchange={(e: any) => handleChange(e, "maximumBudget")}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="action-form">
              { jobStatus !== 2 && <Button disabled={disabledSave} onClick={(e:any) => saveValues(e)} variant="cancel">Save</Button>}
              <Button disabled={disabled} onClick={handleSubmit(publishValues)} variant="primary">Publish</Button>
            </div>
          </div>
    </form>
  );
};
export default CreatePositions;
